const getYearsForRole = (role, availableImpactYears) => {
  if (role === "advanced") return availableImpactYears.slice(0, 2);
  if (role === "basic") return availableImpactYears.slice(0, 1);
  return [];
};

const legacyRolesPermissionsCheck = (
  action,
  permissions,
  institutionId,
  year,
  sdgId,
) => {
  // Has the option to view the overview and details pages in sidebar
  if (
    (action === 'sdgImpact:sideBar:overview' ||
      action === 'sdgImpact:sideBar:details' ||
      action === 'sdgImpact:sideBar:overviewImpact' ||
      action === 'sdgImpact:sideBar:detailsImpact') &&
    permissions[institutionId].some(
      (item) =>
        item === 'IMPACT_EMBARGO' ||
        item.includes('SDG_IMPACT_RELEASE') ||
        item.includes('SDG_IMPACT_SUBSCRIPTION'),
    )
  ) {
    return true;
  }

  // Has the option to view the overview page
  if (
    action === 'sdgImpact:viewPage:overview' &&
    permissions[institutionId].some(
      (item) =>
        item === 'IMPACT_EMBARGO' ||
        item.includes('SDG_IMPACT_RELEASE') ||
        item.includes('SDG_IMPACT_SUBSCRIPTION'),
    )
  ) {
    return true;
  }

  // Has the option to view the details page
  if (
    action === 'sdgImpact:viewPage:details' &&
    permissions[institutionId].some((item) =>
      item.includes('SDG_IMPACT_SUBSCRIPTION'),
    )
  ) {
    return true;
  }

  // Has the option to fetch data for the overview page from the legacy server
  if (
    action === 'sdgImpact:viewData:overview' &&
    permissions[institutionId].some(
      (item) =>
        item.includes('SDG_IMPACT_SUBSCRIPTION') ||
        item.includes('SDG_IMPACT_RELEASE'),
    )
  ) {
    return true;
  }

  // Has the option to fetch data for the details page from the legacy server
  if (
    action === 'sdgImpact:viewData:details' &&
    permissions[institutionId].some(
      (item) =>
        item.includes('SDG_IMPACT_SUBSCRIPTION') ||
        item.includes('SDG_IMPACT_RELEASE'),
    )
  ) {
    return true;
  }

  if (
    action === 'sdgImpact:viewSdg' &&
    permissions[institutionId].some(
      (item) => item === `SDG_IMPACT_SUBSCRIPTION_${year}_${sdgId}`,
    )
  ) {
    return true;
  }

  if (
    action === 'sdgImpact:viewRelease' &&
    permissions[institutionId].some(
      (item) =>
        item.includes(`SDG_IMPACT_SUBSCRIPTION_${year}`) ||
        item.includes(`SDG_IMPACT_RELEASE_${year}`),
    )
  ) {
    return true;
  }

  if (
    action === 'sdgImpact:viewYear' &&
    permissions[institutionId].some(
      (item) =>
        item.includes(`SDG_IMPACT_SUBSCRIPTION_${year}`) ||
        item.includes(`SDG_IMPACT_RELEASE_${year}`),
    )
  ) {
    return true;
  }

  return false;
};

const permissionsCheck = (
  action,
  permissions,
  institutionId,
  year,
  sdgId,
  availableImpactYears,
  isDuringEmbargo,
) => {
  // Has the option to view the overview and details pages in sidebar
  if (
    action === 'sdgImpact:sideBar:overview' ||
    action === 'sdgImpact:sideBar:details' ||
    action === 'sdgImpact:sideBar:overviewImpact' ||
    action === 'sdgImpact:sideBar:detailsImpact'
  ) {
    return true;
  }
  // Has the option to view the overview page
  if (
    action === 'sdgImpact:viewPage:overview' &&
    permissions[institutionId].some(
      (item) =>
        item.includes('SDG_IMPACT_SUBSCRIPTION_PREMIUM') ||
        item.includes('SDG_IMPACT_SUBSCRIPTION_ADVANCED') ||
        item.includes('SDG_IMPACT_SUBSCRIPTION_BASIC'),
    )
  ) {
    return true;
  }

  // Has the option to view the details page
  if (
    action === 'sdgImpact:viewPage:details' &&
    permissions[institutionId].some(
      (item) =>
        item.includes('SDG_IMPACT_SUBSCRIPTION_PREMIUM') ||
        item.includes('SDG_IMPACT_SUBSCRIPTION_ADVANCED'),
    )
  ) {
    return true;
  }

  // Has the option to view overview page details for this specific year
  if (action === 'sdgImpact:overview:viewRelease') {
    // if user has premium subscription, no further year check is necessary
    if (
      permissions[institutionId].some((item) =>
        item.includes('SDG_IMPACT_SUBSCRIPTION_PREMIUM'),
      )
    ) {
      return true;
    }

    // if user does not have advanced subscription we assume basic
    const availableRoleYears = getYearsForRole(
      permissions[institutionId].some((item) =>
        item.includes('SDG_IMPACT_SUBSCRIPTION_ADVANCED'),
      )
        ? 'advanced'
        : 'basic',
      availableImpactYears,
      isDuringEmbargo,
    );

    // check for year
    if (availableRoleYears.includes(Number(year))) {
      return true;
    }
  }

  // Has the option to fetch data for the overview page from the legacy server
  if (
    action === 'sdgImpact:viewData:overview' &&
    permissions[institutionId].some(
      (item) =>
        item.includes('SDG_IMPACT_SUBSCRIPTION_PREMIUM') ||
        item.includes('SDG_IMPACT_SUBSCRIPTION_ADVANCED') ||
        item.includes('SDG_IMPACT_SUBSCRIPTION_BASIC'),
    )
  ) {
    return true;
  }

  // Has the option to fetch data for the details page from the legacy server
  if (
    action === 'sdgImpact:viewData:details' &&
    permissions[institutionId].some(
      (item) =>
        item.includes('SDG_IMPACT_SUBSCRIPTION_PREMIUM') ||
        item.includes('SDG_IMPACT_SUBSCRIPTION_ADVANCED') ||
        item.includes('SDG_IMPACT_SUBSCRIPTION_BASIC'),
    )
  ) {
    return true;
  }

  // Has the option to view that SDG for this specifc year
  if (
    action === 'sdgImpact:viewSdg' &&
    permissions[institutionId].some(
      (item) =>
        item.includes('SDG_IMPACT_SUBSCRIPTION_PREMIUM') ||
        item.includes('SDG_IMPACT_SUBSCRIPTION_ADVANCED'),
    )
  ) {
    // if user has premium subscription, no further year check is necessary
    if (
      permissions[institutionId].some((item) =>
        item.includes('SDG_IMPACT_SUBSCRIPTION_PREMIUM'),
      )
    ) {
      return true;
    }

    // the last two years
    const availableRoleYears = getYearsForRole(
      'advanced',
      availableImpactYears,
      isDuringEmbargo,
    );

    // check for year and access to specific SDG
    if (
      availableRoleYears.includes(Number(year)) &&
      permissions[institutionId].some((item) =>
        [`SDG_IMPACT_SUBSCRIPTION_ADVANCED_${sdgId}`].includes(item),
      )
    ) {
      return true;
    }
  }

  // Check if user has ability to view a specific year
  if (action === 'sdgImpact:viewYear') {
    // if user has premium subscription, no further year check is necessary
    if (
      permissions[institutionId].some((item) =>
        item.includes('SDG_IMPACT_SUBSCRIPTION_PREMIUM'),
      )
    ) {
      return true;
    }

    // if user does not have advanced subscription we assume basic
    const availableRoleYears = getYearsForRole(
      permissions[institutionId].some((item) =>
        item.includes('SDG_IMPACT_SUBSCRIPTION_ADVANCED'),
      )
        ? 'advanced'
        : 'basic',
      availableImpactYears,
      isDuringEmbargo,
    );

    // check for year
    if (availableRoleYears.includes(Number(year))) {
      return true;
    }
  }

  return false;
};

const sdgImpactPermissions = (
  action,
  permissions,
  institutionId,
  year,
  sdgId,
  availableImpactYears,
  isDuringEmbargo,
) => {
  // if user has the new impact permissions, don't check legacy permissions
  if (
    permissions[institutionId].some(
      (item) =>
        item.includes('SDG_IMPACT_SUBSCRIPTION_PREMIUM') ||
        item.includes('SDG_IMPACT_SUBSCRIPTION_ADVANCED') ||
        item.includes('SDG_IMPACT_SUBSCRIPTION_BASIC'),
    )
  ) {
    return permissionsCheck(
      action,
      permissions,
      institutionId,
      year,
      sdgId,
      availableImpactYears,
      isDuringEmbargo,
    );
  }

  return legacyRolesPermissionsCheck(
    action,
    permissions,
    institutionId,
    year,
    sdgId,
    availableImpactYears,
  );
};

module.exports = {
  sdgImpactPermissions,
};
